/* eslint-disable */
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const GROWTH_COLOR = '#43f043';
const REMAINDER_COLOR = '#d7edd3';

const RevenueDoughnutChart = ({ percentage, title = 'Revenue Growth' }) => {
  const numericPercentage = typeof percentage === 'number' ? percentage : 0;
  const actualPercentage = Math.min(100, Math.max(0, numericPercentage));
  const remainder = 100 - actualPercentage;

  const data = {
    labels: ['Revenue Growth', 'Remainder'],
    datasets: [
      {
        data: [actualPercentage, remainder],
        backgroundColor: [GROWTH_COLOR, REMAINDER_COLOR],
        hoverBackgroundColor: [GROWTH_COLOR, REMAINDER_COLOR],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.parsed || 0;
            return `${label}: ${value.toFixed(2)}%`;
          },
        },
      },
    },
  };

  return (
    <div style={{ 
        width: '100%', 
        maxWidth: '250px',
        height: '155px', 
        margin: 'auto', 
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
      {/* <h3 style={{ marginBottom: '10px' }}>{title}</h3> */}
      
      <div style={{ width: '100%', height: '100%', position: 'relative' }}>
        <Doughnut data={data} options={options} />
        
        {/* Display the main percentage value in the center */}
        <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '2em',
            fontWeight: 'bold',
            color: GROWTH_COLOR,
            lineHeight: '1.2',
            animation: 'blink 1.5s infinite'  
        }}>
          {`${actualPercentage.toFixed(0)}%`}
        </div>
        <style>
          {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0; }
              100% { opacity: 1; }
            }
          `}
          </style>
      </div>
    </div>
    
  );
};

export default RevenueDoughnutChart;